import React from "react";
import PropTypes from "prop-types";
import window from "global/window";

const NavigationPageButton = ({
    currentPage,
    pageSize,
    active,
    previous,
    next,
    goTo,
    currentPageUrlPrefix,
    pageSizeUrlPrefix,
    children
}) => {
    if(previous) {
        currentPage = currentPage -1;
    } else if (next){
        currentPage = currentPage +1;
    }

    let href= "";
    let currentParams = window && window.location && window.location.search ? window.location.search : "";

    if(currentPageUrlPrefix.includes("?") || pageSizeUrlPrefix.includes("?")){
        currentParams = currentParams.replace(new RegExp(`\\${currentPageUrlPrefix}[a-zA-Z0-9]+`, "i"),"");
        currentParams = currentParams.replace(new RegExp(`\\${pageSizeUrlPrefix}[a-zA-Z0-9]+`, "i"),"");
        currentParams = currentParams.replace("?","&");
    }

    href = `${currentPageUrlPrefix}${currentPage}${pageSizeUrlPrefix}${pageSize}${currentParams}`;


    return(
        <a className={`page-button ${active && "active" || ""}`} href={href} onClick={(e)=>{
            e.preventDefault();
            goTo(currentPage, href);
        }}>
            {children}
        </a>
    );
};

NavigationPageButton.defaultProps = {
    currentPageUrlPrefix: "?currentPage=",
    pageSizeUrlPrefix: "&pageSize="
};

NavigationPageButton.propTypes = {
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    active: PropTypes.bool,
    previous: PropTypes.bool,
    next: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    goTo: PropTypes.func,
    currentPageUrlPrefix: PropTypes.string,
    pageSizeUrlPrefix: PropTypes.string
};

export default NavigationPageButton;